export class ConnectModel {

    /**
     * Response status
     */
    success: boolean = false;

    /**
     * Response message
     */
    message: string = '';

    /**
     * Connected account addresses
     */
    accounts: Array<string> = [];

    /**
     * Successful connection
     * 
     * @param accounts
     */
    pass(accounts: Array<string>) {
        this.success = true;
        this.message = '';
        this.accounts = accounts;
    }

    /**
     * Failed connection
     * 
     * @param message 
     */
    fail(message: string) {
        this.success = false;
        this.message = message;
        this.accounts = [];
    }
}